import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from '../../Generic/Typography';
import cardStyles from './VideoCard-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { Button } from '../../Generic/Button';
import i18nMessages from '../../../constants/messages/pt-BR';
import { getCdnImage } from "../../../utils/ImageManager"
import DOMPurify from 'isomorphic-dompurify';

class VideoCarousel extends React.Component {
  state = {
    showVideo: false,
  };
  componentDidMount() {
    window.addEventListener(i18nMessages.scroll, this.scrollVideoHandler);
    this.scrollVideoHandler();
  }
  componentWillUnmount() {
    window.removeEventListener(i18nMessages.scroll, this.scrollVideoHandler);
  }
  onClickHandler = () => {
    this.setState({ showVideo: true });
  };
  scrollVideoHandler = () => {
    const { data } = this.props;
    const videoDiv = document.getElementById(data.sys.id);
    // Get it's position in the viewport
    const bounding = videoDiv && videoDiv.getBoundingClientRect();
    const iframes =
      videoDiv &&
      videoDiv.getElementsByTagName(i18nMessages.iframe)[0].contentWindow;
    // Log the results
    if (
      bounding &&
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight)
    ) {
      return null;
    } else {
      iframes &&
        iframes.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
    }
  };

  onClickHandler = () => {
    this.setState({ showVideo: true });
  };
  render() {
    const { cardType = i18nMessages.VideoCarousel, data } = this.props;
    const { showVideo } = this.state;
    let cardTypestyle = (data.styles && data.styles.trim()) || cardType;
    if (cardStyles[cardTypestyle] === undefined) {
      cardTypestyle = cardType;
    }
    if (cardStyles[cardTypestyle].card === undefined) {
      cardStyles[cardTypestyle] = i18nMessages.VideoCarousel;
    }

    const widthClass = getWidth(data.componentWidth);
    const videoData = data.video;
    const autoPlayVideo = videoData.autoplay ? 1 : 0;
    return (
      <div className={classNames(widthClass, cardStyles[cardTypestyle].card)}>
        {!showVideo && (
          <div className={classNames(cardStyles[cardTypestyle].mediaWrapper)}>
            {videoData.videoThumbnail && videoData.videoThumbnail.url && (
              <img
                className={classNames(cardStyles[cardTypestyle].thumbnailImage)}
                alt={videoData.videoThumbnail.alt}
                src={getCdnImage(videoData.videoThumbnail.url)}
              />
            )}

            {data.callToActionsCollection && (
              <div
                className={classNames(cardStyles[cardTypestyle].cardActions)}
              >
                {data.callToActionsCollection.items.map(item => {
                  if (item.__typename === i18nMessages.ImageButton) {
                    return (
                      <div
                        className={cardStyles[cardTypestyle].buttonContainer}
                      >
                        <Button onClick={this.onClickHandler}>
                          <img
                            className={classNames(
                              cardStyles[cardTypestyle].playButton
                            )}
                            alt={item.alt}
                            src={getCdnImage(item.image.url)}
                          />
                        </Button>
                      </div>
                    );
                  }
                })}
              </div>
            )}
          </div>
        )}

        {showVideo && (
          <div
            className={classNames(
              cardStyles[cardTypestyle].videoWrapper,
              'w-full'
            )}
            id={`${data.sys.id}`}
          >
            <div className={classNames(cardStyles.videoWrapper)}>
              <iframe
                title="video"
                className={`${data.sys.id}`}
                src={`${videoData.videoLink}?rel=0&amp;autoplay=${autoPlayVideo}&enablejsapi=1`}
                style={{
                  width: '100%',
                  height: '100%',
                }}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            </div>
          </div>
        )}
        <div className={classNames(cardStyles[cardTypestyle].cardContent)}>
          {data.title && (
            <Typography
              className={classNames(cardStyles[cardTypestyle].header)}
              component="h2"
              dangerouslySetInnerHTML={{
                __html:DOMPurify.sanitize( data.title),
              }}
            />
          )}
          {data.text && (
            <Typography
              className={classNames(cardStyles[cardTypestyle].description)}
              component="div"
              dangerouslySetInnerHTML={{
                __html:DOMPurify.sanitize( data.text),
              }}
            />
          )}
        </div>
      </div>
    );
  }
}
VideoCarousel.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
  cardType: PropTypes.string,
};
// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const VideoCarousel = ({prop = val, data = null, cardType = 'VideoCarousel' }) =>
export default VideoCarousel;
